"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JSONColorModelInfoConverter = void 0;
var color_model_info_1 = require("../../color/color-model-info");
var enums_1 = require("../../color/enums");
var json_character_enums_1 = require("../enums/json-character-enums");
var JSONColorModelInfoConverter = (function () {
    function JSONColorModelInfoConverter() {
    }
    JSONColorModelInfoConverter.convertFromJSON = function (obj) {
        switch (obj[json_character_enums_1.JSONColorModelInfoProperty.ColorType]) {
            case enums_1.ColorType.Auto:
                return color_model_info_1.ColorModelInfo.auto;
            case enums_1.ColorType.Index:
                return color_model_info_1.ColorModelInfo.makeByColorIndex(obj[json_character_enums_1.JSONColorModelInfoProperty.ColorIndex], obj[json_character_enums_1.JSONColorModelInfoProperty.Tint]);
            case enums_1.ColorType.Rgb:
                return color_model_info_1.ColorModelInfo.makeByColor(obj[json_character_enums_1.JSONColorModelInfoProperty.Rgb], obj[json_character_enums_1.JSONColorModelInfoProperty.Tint]);
            case enums_1.ColorType.Theme:
                return color_model_info_1.ColorModelInfo.makeByThemeColorIndex(obj[json_character_enums_1.JSONColorModelInfoProperty.ThemeColorIndex], obj[json_character_enums_1.JSONColorModelInfoProperty.Tint]);
        }
    };
    JSONColorModelInfoConverter.convertToJSON = function (source) {
        return source.toJSON();
    };
    return JSONColorModelInfoConverter;
}());
exports.JSONColorModelInfoConverter = JSONColorModelInfoConverter;
